export default __webpack_public_path__ + "static/media/JKL.330ef45b.jpg";